var _ellipse, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoverMinitour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 45.5,
    rx: 38,
    ry: 38.5,
    fill: "#FDE8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 45C5.5 66.8153 23.1847 84.5 45 84.5C66.8152 84.5 84.5 66.8153 84.5 45C84.5 23.1848 66.8152 5.5 45 5.5C23.1847 5.5 5.5 23.1848 5.5 45Z",
    fill: "#FDE8F2",
    stroke: "#EC187B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1687 27.4547C24.5595 26.5277 24.6852 25.3004 25.4695 24.516C26.2539 23.7317 27.4812 23.606 28.4082 24.2152L48.6576 37.5219C49.7982 38.2715 50.7733 39.2466 51.5228 40.3872L64.8296 60.6366C65.4387 61.5635 65.3131 62.7909 64.5287 63.5752C63.7444 64.3596 62.517 64.4852 61.5901 63.8761L41.3407 50.5693C40.2001 49.8198 39.225 48.8447 38.4754 47.7041L25.1687 27.4547Z",
    fill: "#EC187B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.9524,
    cy: 45.9527,
    r: 2.85714,
    fill: "#FDE8F2",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverMinitour);
export default __webpack_public_path__ + "static/media/hover-minitour.d1cd9e2ba2e70dcb6af61ae2edc4e31e.svg";
export { ForwardRef as ReactComponent };